export enum Experiment {
  UseNotificationsV2Api = 'specs.ping.membersAreaUseNotificationsV2Api',
  HideNotificationsCounterInDropdownAndMemberMenus = 'specs.ping.membersArea.hideNotificationsCounterInDropdownAndMemberMenus',
  AddStandalonePagesRoutesToPublicAppData = 'specs.membersArea.addStandalonePageRoutesToPublicAppData',
  AddV1ContextCheck = 'specs.membersArea.addV1ContextCheck',
  LoginSocialBarBuyAgain = 'specs.membersArea.loginSocialBarBuyAgain',
}
